import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AgoraChat from "./components/AgoraChat";

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/chat/:userId/:adminId" element={<AgoraChat />} />
            </Routes>
        </Router>
    );
};

export default App;
